module.exports = __webpack_public_path__ + "static/media/note.7257713b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Courses/note.png
// module id = 1812
// module chunks = 0